import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Animated } from 'react-native';
import { useDimensionAnimation } from './AnimationHooks';
export function FadeView({ style, children, visible, duration, delay, onLayout }) {
    const [isVisible, setIsVisible] = useState(false);
    const [opacity, setOpacity] = useDimensionAnimation({ initialValue: 0, duration: duration || 300, delay, nativeDriver: true });
    useEffect(() => {
        const value = visible
            ? 1
            : 0;
        setOpacity(value);
        let timeout = null;
        if (!visible) {
            timeout = setTimeout(() => {
                setIsVisible(!!visible);
            }, duration || 300);
        }
        else {
            timeout = setIsVisible(!!visible);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [visible]);
    return (_jsx(Animated.View, { style: [style, { opacity }], onLayout: onLayout, children: isVisible && children }));
}
